<div class="relative mt-8 flex flex-auto flex-col items-center gap-8">
  @if (sms(); as sms) {
    <div class="w-full max-w-3xl">
      <div
        class="surface-default flex flex-col sm:flex-row sm:items-center justify-between gap-4 rounded-xl border border-gray-5 p-5 shadow-xs"
      >
        <div class="flex flex-col gap-2">
          <div class="font-semibold text-base text-neutral-12">
            {{ sms.action | smsActionDisplay }}
          </div>
          <div class="text-xs text-neutral-10">Catégorie : {{ sms.tag | smsTagDisplay }}</div>
          <div class="flex items-center gap-2 text-xs">
            <span
              class="inline-flex items-center px-2.5 py-0.5 rounded-full font-semibold"
              [class.bg-green-3]="sms.status === smsStatus.SENT"
              [class.text-green-11]="sms.status === smsStatus.SENT"
              [class.bg-red-3]="sms.status === smsStatus.CANCELED"
              [class.text-red-11]="sms.status === smsStatus.CANCELED"
              [class.bg-amber-3]="
                sms.status === smsStatus.PENDING ||
                sms.status === smsStatus.ENQUEUED ||
                sms.status === smsStatus.PROCESSING
              "
              [class.text-amber-11]="
                sms.status === smsStatus.PENDING ||
                sms.status === smsStatus.ENQUEUED ||
                sms.status === smsStatus.PROCESSING
              "
            >
              {{ sms.status | smsStatusDisplay }}
            </span>
            @if (sms.status === smsStatus.SENT && sms.sendDate) {
              <span class="text-neutral-11"> le {{ sms.sendDate | luxonDate: 'dd/LL/yyyy, HH:mm' }} </span>
            }
          </div>
        </div>

        <div class="flex items-center gap-2 shrink-0">
          <button mat-flat-button class="primary text-xs!" [disabled]="isResending()" (click)="onResend()">
            <mat-icon class="mr-1 text-sm! w-4! h-4!" [class.animate-spin]="isResending()">
              {{ isResending() ? 'hourglass_empty' : 'send' }}
            </mat-icon>
            {{ isResending() ? 'Envoi en cours...' : 'Renvoyer le SMS' }}
          </button>
        </div>
      </div>
    </div>

    <div class="w-full max-w-3xl">
      <div class="surface-default w-full rounded-xl border border-gray-5 p-5 shadow-xs flex flex-col gap-5">
        <!-- User / Recipient header -->
        <div class="flex flex-wrap items-center justify-between gap-4">
          <div class="flex items-center gap-3.5">
            @if (sms.context.user; as user) {
              <aura-avatar
                [label]="user.identity.firstName"
                [srcImage]="user.identity.avatar?.url"
                [size]="'l'"
              />
            }

            <div class="flex flex-col">
              <div class="text-base font-semibold">
                @if (sms.context.user; as user) {
                  <a
                    class="link text-base font-semibold hover:underline"
                    [matTooltip]="'Utilisateur'"
                    [routerLink]="['/users', user._id]"
                  >
                    {{ user.identity.firstName | titlecase }}
                    {{ user.identity.lastName | titlecase }}
                  </a>
                } @else if (sms.context.userRegistration; as userRegistration) {
                  <a
                    class="link text-base font-semibold hover:underline"
                    [matTooltip]="'Inscription'"
                    [routerLink]="['/user-registrations', userRegistration._id]"
                  >
                    {{ userRegistration.identity.firstName | titlecase }}
                    {{ userRegistration.identity.lastName | titlecase }}
                  </a>
                }
              </div>

              <div class="flex items-center gap-2 text-xs text-neutral-10 mt-0.5">
                @if (sms.from) {
                  <span class="inline-flex items-center gap-1">
                    <mat-icon class="text-xs! size-3.5! leading-3.5!">call_made</mat-icon>
                    <span>De : {{ sms.from }}</span>
                  </span>
                  <span>•</span>
                }
                <span class="inline-flex items-center gap-1 font-medium text-neutral-12">
                  <mat-icon class="text-xs! size-3.5! leading-3.5!">smartphone</mat-icon>
                  <span>À : {{ sms.to }}</span>
                </span>
              </div>
            </div>
          </div>

          <!-- Creation / update dates -->
          <div class="flex flex-col items-end gap-1 text-xs text-neutral-10">
            <div
              class="flex items-center gap-1"
              [matTooltip]="'Créé : ' + (sms.createdAt | luxonDate: 'dd/LL/yyyy HH:mm')"
            >
              <mat-icon class="text-xs! size-3.5! leading-3.5!">schedule</mat-icon>
              <span>{{ sms.createdAt | luxonDate: 'dd/LL/yyyy HH:mm' }}</span>
            </div>
            @if (sms.gatewayMessageId) {
              <div class="font-mono text-[11px] text-neutral-9" [matTooltip]="'ID de message passerelle'">
                ID : {{ sms.gatewayMessageId }}
              </div>
            }
          </div>
        </div>

        <mat-divider></mat-divider>

        <!-- SMS Content preview -->
        <div class="flex flex-col gap-2">
          <div class="flex items-center justify-between text-xs text-neutral-10">
            <span class="font-medium text-neutral-11">Message</span>
            <span>{{ sms.content.length }} caractères</span>
          </div>

          <div
            class="rounded-xl border border-neutral-4 bg-neutral-2 p-4 text-sm leading-relaxed text-neutral-12"
          >
            <p class="whitespace-pre-wrap select-text font-normal">{{ sms.content }}</p>
          </div>
        </div>
      </div>
    </div>
  }
</div>
